import React, { useCallback } from 'react';
import Slider from 'rc-slider';
import 'rc-slider/assets/index.css';
import { INumberSlider } from 'interfaces/numberSlider';

const handleStyle = { borderColor: '#41BD64', borderRadius: '0px' };
  
const trackStyle = { background: '#41BD64', height: '6px' };
  
const NumberSlider = (props: INumberSlider) => {

  const { value, onChange, minRange = 0, maxRange = 500 } = props;

  const handleValueChange = useCallback((number) => {
    onChange(number);
  }, []);

  return (
    <div className="container">
      <Slider 
        onChange={handleValueChange} 
        value={value}
        min={minRange}
        max={maxRange}
        railStyle={{
          height: 2,
        }}
        marks={{ [value]: { label: value }}}
        trackStyle={trackStyle}
        handleStyle={handleStyle}
      />
    </div>
  );
};

export default NumberSlider;